module.exports = "/images/vendor/flag-icon-css/flags/4x3/ck.svg?960a7b5a2c2322b898007c4611cecfd0";